import http from "@/plugin/axios";
// import { Apis } from '../index';
import { getSubName } from "@/utils/getHost";
export default {
  /**
   * 问卷功能调用的接口
   */
  removeSubjectRedis: (data: any): Promise<any> => {
    return http.post("activity/redis/removeSubjectRedis", data);
  },
  /**
   * pc--保存问卷
   */
  saveOrUpdateWxQuestion: (data: any): Promise<any> => {
    if (getSubName() == "longyixiu") {
      data.appletSource = 1;
    } else if (getSubName() == "wenjuanjia") {
      data.appletSource = 7;
    }
    return http.post("activity/question/saveOrUpdateWxQuestion", data);
  },
  /**
   * pc--选择题型
   */
  createSubject: (data: any): Promise<any> => {
    return http.post("activity/question/createSubject", data);
  },
  /**
   * pc--问卷
   */
  getWxQuestion: (data: any): Promise<any> => {
    return http.post("activity/question/getWxQuestion", data);
  },
  /**
   * pc--问卷题目
   */
  getSubject: (data: any): Promise<any> => {
    return http.post("/v2/activity/question/getSubject", data);
  },
  /**
   * pc--问卷调查设置详情
   */
  getWxQuestionSetting: (data: any): Promise<any> => {
    return http.post("activity/question/getWxQuestionSetting", data);
  },
  /**
   * pc--题目移动
   */
  getSubjectMoveList: (data: any): Promise<any> => {
    return http.post("activity/question/getSubjectMoveList", data);
  },
  /**
   * pc--题目选项移动
   */
  getSubjectOptionMoveList: (data: any): Promise<any> => {
    return http.post("activity/question/getSubjectOptionMoveList", data);
  },
  /**
   * pc--更新问卷
   */
  updateWxQuestion: (data: any): Promise<any> => {
    return http.post("activity/question/updateWxQuestion", data);
  },
  /**
   * pc--更新问卷内容
   */
  updateWxQuestionSubject: (data: any): Promise<any> => {
    return http.post("activity/question/updateWxQuestionSubject", data);
  },
  /**
   * pc--更新题目选项
   */
  updateSubjectOption: (data: any): Promise<any> => {
    return http.post("activity/question/updateSubjectOption", data);
  },
  /**
   * pc--更新问卷设置
   */
  updateWxQuestionSetting: (data: any): Promise<any> => {
    return http.post("activity/question/updateWxQuestionSetting", data);
  },
  /**
   * pc--题目删除
   */
  getSubjectDel: (data: any): Promise<any> => {
    return http.post("activity/question/getSubjectDel", data);
  },
  /**
   * pc--题目复制
   */
  getSubjectCopy: (data: any): Promise<any> => {
    return http.post("activity/question/getSubjectCopy", data);
  },
  /**
   * pc--添加选项
   */
  addOption: (data: any): Promise<any> => {
    return http.post("activity/question/addOption", data);
  },
  /**
   * pc--删除选项
   */
  delOption: (data: any): Promise<any> => {
    return http.post("activity/question/delOption", data);
  },
  /**
   * pc--批量添加选项
   */
  batchAddOption: (data: any): Promise<any> => {
    return http.post("activity/question/batchAddOption", data);
  },
  /**
   * pc--批量添加图片选项
   */
  picPatchAddOption: (data: any): Promise<any> => {
    return http.post("activity/question/picPatchAddOption", data);
  },
  /**
   * pc--导入选项--级联题导入数据
   */
  getImpOption: (data: any): Promise<any> => {
    return http.post("activity/question/getImpOption", data);
  },
  /**
   * pc--量表题分值说明列表
   */
  getOptionGaugeList: (data: any): Promise<any> => {
    return http.post("activity/question/getOptionGaugeList", data);
  },
  /**
   * pc--更新选项--分值说明
   */
  updateOptionGauge: (data: any): Promise<any> => {
    return http.post("activity/question/updateOptionGauge", data);
  },
  /**
   * pc--保存标签设置
   */
  saveOrUpdateGaugeLabel: (data: any): Promise<any> => {
    return http.post("activity/question/saveOrUpdateGaugeLabel", data);
  },
  /**
   * pc--级联数据
   */
  getCascadeList: (data: any): Promise<any> => {
    return http.post("activity/question/getCascadeList", data);
  },
  /**
   * pc--矩阵列题目移动
   */
  getMatrixOptionMoveList: (data: any): Promise<any> => {
    return http.post("activity/question/getMatrixOptionMoveList", data);
  },
  /**
   * pc--更新矩阵列题目
   */
  updateSubjectOptionMatrix: (data: any): Promise<any> => {
    return http.post("activity/question/updateSubjectOptionMatrix", data);
  },
  /**
   * pc--添加矩阵题目选项
   */
  addOptionMatrix: (data: any): Promise<any> => {
    return http.post("activity/question/addOptionMatrix", data);
  },
  /**
   * pc--批量添加矩阵题目选项
   */
  batchAddOptionMatrix: (data: any): Promise<any> => {
    return http.post("activity/question/batchAddOptionMatrix", data);
  },
  /**
   * pc--删除矩阵列题目选项
   */
  delOptionMatrix: (data: any): Promise<any> => {
    return http.post("activity/question/delOptionMatrix", data);
  },
  /**
   * pc--保存OR更新文件格式
   */
  saveOrUpdateFormat: (data: any): Promise<any> => {
    return http.post("activity/question/saveOrUpdateFormat", data);
  },
  /**
   * 问卷报表--问卷统计
   */
  getQuestionStatement: (data: any): Promise<any> => {
    return http.post("question/statement/getQuestionStatement", data);
  },
  /**
   * 问卷报表--分类报表
   */
  getQuestionStatementType: (data: any): Promise<any> => {
    return http.post("question/statement/getQuestionStatementType", data);
  },
  /**
   * 问卷报表--分类报表--分页
   */
  getQuestionStatementTypePage: (data: any): Promise<any> => {
    return http.post("question/statement/getQuestionStatementTypePage", data);
  },
  /**
   * 分类报表--级联等级
   */
  getQuestionStatementTypeByCascadeLevel: (data: any): Promise<any> => {
    return http.post(
      "question/statement/getQuestionStatementTypeByCascadeLevel",
      data
    );
  },
  /**
   * 分类报表--级联选项
   */
  getSubjectByCascadeLevel: (data: any): Promise<any> => {
    return http.post("question/statement/getSubjectByCascadeLevel", data);
  },
  /**
   * 问卷报表—数据详情
   */
  getQuestionDataDetail: (data: any): Promise<any> => {
    return http.post("/v2/question/statement/getQuestionDataDetail", data);
  },
  /**
   * 问卷报表--题目条件
   */
  getStatementSubject: (data: any): Promise<any> => {
    return http.post("/v2/question/statement/getStatementSubject", data);
  },

  /**
   * 问卷报表--批量修改问卷数据详情状态
   */
  getStatementStatus: (data: any): Promise<any> => {
    return http.post("question/statement/getStatementStatus", data);
  },
  /**
   * 问卷报表—数据详情
   */
  getStatementDetail: (data: any): Promise<any> => {
    return http.post("question/statement/getStatementDetail", data);
  },
  /**
   * pc--修改问卷状态
   */
  getQuestionStatus: (data: any): Promise<any> => {
    return http.post("activity/question/getQuestionStatus", data);
  },
  /**
   * 逻辑题目列表
   */
  getSubjectList: (data: any): Promise<any> => {
    return http.post("activity/question/logic/getSubjectList", data);
  },
  /**
   * 问卷逻辑列表
   */
  getLogicList: (data: any): Promise<any> => {
    return http.post("activity/question/logic/getLogicList", data);
  },
  /**
   * 保存OR更新逻辑
   */
  saveOrUpdateWxQuestionLogic: (data: any): Promise<any> => {
    return http.post(
      "activity/question/logic/saveOrUpdateWxQuestionLogic",
      data
    );
  },
  /**
   * 删除跳转或显示逻辑
   */
  delLogicJump: (data: any): Promise<any> => {
    return http.post("activity/question/logic/delLogicJump", data);
  },
  /**
   * 删除显示逻辑子项
   */
  delLogic: (data: any): Promise<any> => {
    return http.post("activity/question/logic/delLogic", data);
  },
  /**
   * pc--复制问卷
   */
  getQuestionCopy: (data: any): Promise<any> => {
    return http.post("activity/question/getQuestionCopy", data);
  },
  /**
   * pc--清空数据
   */
  getQuestionClear: (data: any): Promise<any> => {
    return http.post("activity/question/getQuestionClear", data);
  },
  /**
   * 问卷报表--答卷详情
   */
  getStatementSubjectDataDetail: (data: any): Promise<any> => {
    return http.post("question/statement/getStatementSubjectDataDetail", data);
  },
  /**
   * 问卷报表--人工评分--分数
   */
  getStatementByManualScore: (data: any): Promise<any> => {
    return http.post("question/statement/getStatementByManualScore", data);
  },
  /**
   * 问卷报表—人工评分--是否正确
   */
  getStatementByIsManual: (data: any): Promise<any> => {
    return http.post("question/statement/getStatementByIsManual", data);
  },
  /**
   * pc--问卷二维码
   */
  getQuestionCode: (data: any): Promise<any> => {
    if (getSubName() == "wenjuanjia") {
      data.appletSource = 7;
    }
    return http.post("activity/question/getQuestionCode", data);
  },
  /**
   * 导出--数据详情
   */
  getExportExcelDownload: (data: any): Promise<any> => {
    return http.post("/v2/question/statement/getExportExcelDownload", data);
  },
  /**
   * pc-问卷官网--问卷模板详情
   */
  getWxQuestionTemplateDetail: (data: any): Promise<any> => {
    return http.post("/activity/question/getWxQuestionTemplateDetail", data);
  },
  /**
   * pc-问卷官网--问卷热门模板
   */
  getWxQuestionHotTemplate: (data: any): Promise<any> => {
    return http.post("/activity/question/getWxQuestionHotTemplate", data);
  },
  /**
   * 风格--问卷主题风格
   */
  getThemeList: (data: any): Promise<any> => {
    return http.post("/activity/question/theme/getThemeList", data);
  },
  /**
   * 风格--主题页眉
   */
  getThemeHeaderList: (data: any): Promise<any> => {
    return http.post("/activity/question/theme/getThemeHeaderList", data);
  },
  /**
   * 风格--选择主题
   */
  getThemeSetting: (data: any): Promise<any> => {
    return http.post("/activity/question/theme/getThemeSetting", data);
  },
  /**
   * 风格--问卷主题
   */
  getQuestionTheme: (data: any): Promise<any> => {
    return http.post("/activity/question/theme/getQuestionTheme", data);
  },
  /**
   * 风格--更新主题设置
   */
  updateThemeSetting: (data: any): Promise<any> => {
    return http.post("/activity/question/theme/updateThemeSetting", data);
  },
  /**
   * 考前准备题目
   */
  getPrepareSubject: (data: any): Promise<any> => {
    return http.post("/activity/question/getPrepareSubject", data);
  },
  /**
   *  问卷题库类型列表
   */
  getQuestionBankTypeData: (data: any): Promise<any> => {
    return http.post("/activity/question/bank/getQuestionBankTypeData", data);
  },
  /**
   * pc--题库题目复制
   */
  getSubjectBankCopy: (data: any): Promise<any> => {
    return http.post("/activity/question/getSubjectBankCopy", data);
  },
  /**
   * 问卷题库查询
   */
  getQuestionBankData: (data: any): Promise<any> => {
    return http.post("/activity/question/bank/getQuestionBankData", data);
  },
  /**
   * pc--正常完成的结束语
   */
  getConclusion: (data: any): Promise<any> => {
    return http.post("/activity/question/getConclusion", data);
  },
  /**
   * pc--更新结束语设置
   */
  updateConclusionSetting: (data: any): Promise<any> => {
    return http.post("/activity/question/updateConclusionSetting", data);
  },
  /**
   * pc--更新结束语评语
   */
  updateConclusionComment: (data: any): Promise<any> => {
    return http.post("/activity/question/updateConclusionComment", data);
  },
  /**
   * pc--新增结束语评语
   */
  addConclusionComment: (data: any): Promise<any> => {
    return http.post("/activity/question/addConclusionComment", data);
  },
  /**
   * pc--删除结束语评语
   */
  delConclusionComment: (data: any): Promise<any> => {
    return http.post("/activity/question/delConclusionComment", data);
  },
  /**
   * pc--题库类型题目列表
   */
  getBankTypeSubjectData: (data: any): Promise<any> => {
    return http.post("/activity/question/bank/getBankTypeSubjectData", data);
  },
  /**
   * pc--联系我们
   */
  getSubjectByContactUs: (data: any): Promise<any> => {
    return http.post("/activity/question/getSubjectByContactUs", data);
  },
  /**
   * 风格--系统封面
   */
  getSysCoverList: (data: any): Promise<any> => {
    return http.post("/activity/question/theme/getSysCoverList", data);
  },
  /**
   * 风格--查询问卷的音乐
   */
  getLocalMusicByQuestionId: (data: any): Promise<any> => {
    return http.post(
      "/activity/question/theme/getLocalMusicByQuestionId",
      data
    );
  },
  /**
   * 风格--查询问卷的音乐
   */
  getMusicByQuestionId: (data: any): Promise<any> => {
    return http.post("/activity/question/theme/getMusicByQuestionId", data);
  },
  /**
   * 风格--保存问卷音乐
   */
  saveOrUpdateMusicQuestion: (data: any): Promise<any> => {
    return http.post("/activity/question/theme/saveOrUpdateMusic", data);
  },
  /**
   * 更新问卷详情总分数
   */
  updateQuestionDetailByScore: (data: any): Promise<any> => {
    return http.post("/question/statement/updateQuestionDetailByScore", data);
  },
  /**
   * 问卷详情分数排行
   */
  getQuestionScoreRank: (data: any): Promise<any> => {
    return http.post("/v2/question/statement/getQuestionScoreRank", data);
  },
  /**
   * 删除分数排行
   */
  delScoreRank: (data: any): Promise<any> => {
    return http.post("/question/statement/delScoreRank", data);
  },
  /**
   * 分数排行榜下载
   */
  getScoreExcelDownload: (data: any): Promise<any> => {
    return http.post("/v2/question/statement/getScoreExcelDownload", data);
  },
  /**
   * 随机抽题设置list
   */
  getRandomSubjectList: (data: any): Promise<any> => {
    return http.post("/activity/question/getRandomSubjectList", data);
  },
  /**
   * 保存设置随机抽题
   */
  getRandomSubjectSetting: (data: any): Promise<any> => {
    return http.post("/activity/question/getRandomSubjectSetting", data);
  },
  /**
   * pc--问卷接龙名单list
   */
  getSolitaireNameList: (data: any): Promise<any> => {
    return http.post("/activity/question/solitaire/getSolitaireNameList", data);
  },
  /**
   * pc--问卷接龙名单内容
   */
  getSolitaireNameDetail: (data: any): Promise<any> => {
    return http.post(
      "/activity/question/solitaire/getSolitaireNameDetail",
      data
    );
  },
  /**
   * pc--保存or更新接龙名单
   */
  saveOrUpdateSolitaire: (data: any): Promise<any> => {
    return http.post(
      "/activity/question/solitaire/saveOrUpdateSolitaire",
      data
    );
  },
  /**
   * pc--删除接龙名单
   */
  delSolitaireName: (data: any): Promise<any> => {
    return http.post("/activity/question/solitaire/delSolitaireName", data);
  },
  /**
   * pc--获取邀请码
   */
  getTeamWorkCode: (data: any): Promise<any> => {
    return http.post("/code/getTeamWorkCode", data);
  },
  /**
   * pc--更新邀请码类型
   */
  updateWorkType: (data: any): Promise<any> => {
    return http.post("/code/updateWorkType", data);
  },
  /**
   * pc--保存团队协作员
   */
  saveOrUpdateTeamWork: (data: any): Promise<any> => {
    return http.post("/code/saveOrUpdateTeamWork", data);
  },
  /**
   * pc--团队协作者list
   */
  getTeamWorkList: (data: any): Promise<any> => {
    return http.post("/code/getTeamWorkList", data);
  },
  /**
   * pc--更新协作者权限
   */
  updateTeamWorkType: (data: any): Promise<any> => {
    return http.post("/code/updateTeamWorkType", data);
  },
  /**
   * pc--删除协作者
   */
  delTeamWork: (data: any): Promise<any> => {
    return http.post("/code/delTeamWork", data);
  },
  /**
   * 导入问卷题目
   */
  getImportSubject: (data: any): Promise<any> => {
    return http.post("/activity/question/getImportSubject", data);
  },
  /**
   * 导入问卷
   */
  getImportQuestion: (data: any): Promise<any> => {
    return http.post("/activity/question/getImportQuestion", data);
  },
  /**
   * 查看物流信息
   */
  getLogistics: (data: any): Promise<any> => {
    return http.post("/activity/question/logistics/getLogistics", data);
  },
  /**
   * 更新物流
   */
  saveOrUpdateLogistics: (data: any): Promise<any> => {
    return http.post(
      "/activity/question/logistics/saveOrUpdateLogistics",
      data
    );
  },
  /**
   * 保存or更新商品规格
   */
  saveOrUpdateSpecs: (data: any): Promise<any> => {
    return http.post("/activity/question/saveOrUpdateSpecs", data);
  },
  /**
   * 商品规格list
   */
  getCommoditySpecs: (data: any): Promise<any> => {
    return http.post("/activity/question/getCommoditySpecs", data);
  },
  /**
   * 删除规格
   */
  delSpecs: (data: any): Promise<any> => {
    return http.post("/activity/question/delSpecs", data);
  },
  /**
   * 删除规格类型
   */
  delSpecsType: (data: any): Promise<any> => {
    return http.post("/activity/question/delSpecsType", data);
  },
  /**
   * 问卷证书list
   */
  getQuestionCertList: (data: any): Promise<any> => {
    return http.post("/activity/question/getQuestionCertList", data);
  },
  /**
   * 新增证书
   */
  addQuestionCert: (data: any): Promise<any> => {
    return http.post("/activity/question/addQuestionCert", data);
  },
  /**
   * 更新证书
   */
  updateQuestionCert: (data: any): Promise<any> => {
    return http.post("/activity/question/updateQuestionCert", data);
  },
  /**
   * 复制证书
   */
  copyQuestionCert: (data: any): Promise<any> => {
    return http.post("/activity/question/copyQuestionCert", data);
  },
  /**
   * 删除证书
   */
  delQuestionCert: (data: any): Promise<any> => {
    return http.post("/activity/question/delQuestionCert", data);
  },
  /**
   * 证书个数
   */
  getCertDetailCount: (data: any): Promise<any> => {
    return http.post("/activity/question/getCertDetailCount", data);
  },
  /**
   * 查看证书详情信息
   */
  getCertDetail: (data: any): Promise<any> => {
    return http.post("/activity/question/getCertDetail", data);
  },
  /**
   * 领取证书记录
   */
  getCertDetailList: (data: any): Promise<any> => {
    return http.post("/activity/question/getCertDetailList", data);
  },
  /**
   * 是否存在其他题型
   */
  getSubjectByType: (data: any): Promise<any> => {
    return http.post("/activity/question/getSubjectByType", data);
  },
  /**
   * 抽奖设置
   */
  getQuestionDraw: (data: any): Promise<any> => {
    return http.post("/activity/question/draw/getQuestionDraw", data);
  },
  /**
   * 删除奖品
   */
  delDrawPrize: (data: any): Promise<any> => {
    return http.post("/activity/question/draw/delDrawPrize", data);
  },
  /**
   * 更新问卷抽奖
   */
  updateQuestionDraw: (data: any): Promise<any> => {
    return http.post("/activity/question/draw/updateQuestionDraw", data);
  },
  /**
   * 中奖者信息list
   */
  getWinDrawPrize: (data: any): Promise<any> => {
    return http.post("/activity/question/draw/getWinDrawPrize", data);
  },
  /**
   * 更新问卷详情备注
   */
  updateDetailRemark: (data: any): Promise<any> => {
    return http.post("/question/statement/updateDetailRemark", data);
  },
  /**
   * 批量删除题目
   */
  batchDelSubject: (data: any): Promise<any> => {
    return http.post("/activity/question/batchDelSubject", data);
  },
  /**
   * 横向填空答案list
   */
  getTransverseAnswerList: (data: any): Promise<any> => {
    return http.post("/activity/question/getTransverseAnswerList", data);
  },
  /**
   * 更新横向填空答案
   */
  updateTransverseAnswer: (data: any): Promise<any> => {
    return http.post("/activity/question/updateTransverseAnswer", data);
  },
  /**
   * 预约设置
   */
  getAppointSetting: (data: any): Promise<any> => {
    return http.post("/activity/question/appoint/getAppointSetting", data);
  },
  /**
   * 更新预约设置
   */
  updateAppointSetting: (data: any): Promise<any> => {
    return http.post("/activity/question/appoint/updateAppointSetting", data);
  },
  /**
   * 预约周时间
   */
  getAppointWeekList: (data: any): Promise<any> => {
    return http.post("/activity/question/appoint/getAppointWeekList", data);
  },
  /**
   * 更新预约周时间
   */
  updateAppointWeek: (data: any): Promise<any> => {
    return http.post("/activity/question/appoint/updateAppointWeek", data);
  },
  /**
   * 批量更新周时间的名额
   */
  batchUpdateAppointWeekList: (data: any): Promise<any> => {
    return http.post(
      "/activity/question/appoint/batchUpdateAppointWeekList",
      data
    );
  },
  /**
   * 预约周时间段
   */
  getAppointWeekTimeList: (data: any): Promise<any> => {
    return http.post("/activity/question/appoint/getAppointWeekTimeList", data);
  },
  /**
   * 保存Or更新周时间段
   */
  saveOrUpdateWeekTime: (data: any): Promise<any> => {
    return http.post("/activity/question/appoint/saveOrUpdateWeekTime", data);
  },
  /**
   * 删除周时间段信息
   */
  delWeekTime: (data: any): Promise<any> => {
    return http.post("/activity/question/appoint/delWeekTime", data);
  },
  /**
   * 批量更新周时间段名额
   */
  batchUpdateWeekTimeList: (data: any): Promise<any> => {
    return http.post(
      "/activity/question/appoint/batchUpdateWeekTimeList",
      data
    );
  },
  /**
   * 不可约时间
   */
  getAppointTimeList: (data: any): Promise<any> => {
    return http.post("/activity/question/appoint/getAppointTimeList", data);
  },
  /**
   * 保存OR更新不可约日期
   */
  saveOrUpdateAppointTime: (data: any): Promise<any> => {
    return http.post(
      "/activity/question/appoint/saveOrUpdateAppointTime",
      data
    );
  },
  /**
   * 删除不可约时间
   */
  delAppointTime: (data: any): Promise<any> => {
    return http.post("/activity/question/appoint/delAppointTime", data);
  },
  /**
   * 问卷详情 上一条 下一条
   */
  getLastOrNextQuestionDetail: (data: any): Promise<any> => {
    return http.post("/question/statement/getLastOrNextQuestionDetail", data);
  },
  /**
   * 核销
   */
  getWinDrawPrizeToVerify: (data: any): Promise<any> => {
    return http.post("/activity/question/draw/getWinDrawPrizeToVerify", data);
  },
  /**
   * 16715定制
   */
  getMadeScoreExcelDownload: (data: any): Promise<any> => {
    return http.post("/question/statement/getMadeScoreExcelDownload", data);
  },
  /**
   * 下载奖品
   */
  downloadWinDrawPrize: (data: any): Promise<any> => {
    return http.post("/activity/question/draw/downloadWinDrawPrize", data);
  },
  /**
   * 删除奖品信息
   */
  delWinDrawPrize: (data: any): Promise<any> => {
    return http.post("/activity/question/draw/delWinDrawPrize", data);
  },
  /**
   * 保存红包设置
   */
  saveRedPackSetting: (data: any): Promise<any> => {
    return http.post("/activity/question/redPack/saveRedPackSetting", data);
  },
  /**
   * 红包设置列表
   */
  getRedPackSettingList: (data: any): Promise<any> => {
    return http.post("/activity/question/redPack/getRedPackSettingList", data);
  },
  /**
   * 更改红包概率
   */
  upDateProbability: (data: any): Promise<any> => {
    return http.post("/activity/question/redPack/upDateProbability", data);
  },
  /**
   * 更改抽奖时间
   */
  upDateDrawTime: (data: any): Promise<any> => {
    return http.post("/activity/question/redPack/upDateDrawTime", data);
  },
  /**
   * 问卷红包--微信支付
   */
  wxPay: (data: any): Promise<any> => {
    return http.post("/active/pay/wxPay", data);
  },
  /**
   * 问卷红包--支付状态查询
   */
  getWxPayStatus: (data: any): Promise<any> => {
    return http.post("/active/pay/getWxPayStatus", data);
  },
  /**
   * 问卷红包--余额支付红包
   */
  getBalancePayPack: (data: any): Promise<any> => {
    return http.post("/recharge/getBalancePayPack", data);
  },
  /**
   * 删除红包设置
   */
  delRedPackSetting: (data: any): Promise<any> => {
    return http.post("/activity/question/redPack/delRedPackSetting", data);
  },
  /**
   * 取消红包设置
   */
  cancelRedPackSetting: (data: any): Promise<any> => {
    return http.post("/activity/question/redPack/cancelRedPackSetting", data);
  },
  /**
   * 红包中奖名单
   */
  getRedParkByWinDraw: (data: any): Promise<any> => {
    return http.post("/activity/question/redPack/getRedParkByWinDraw", data);
  },
  /**
   * 待审核红包详情
   */
  getRedParkByExamine: (data: any): Promise<any> => {
    return http.post("/activity/question/redPack/getRedParkByExamine", data);
  },
  /**
   * 批量审核红包
   */
  getExamineList: (data: any): Promise<any> => {
    return http.post("/activity/question/redPack/getExamineList", data);
  },
  /**
   * 添加结束语题目设置
   */
  addConclusionSubject: (data: any): Promise<any> => {
    return http.post("/activity/question/addConclusionSubject", data);
  },
  /**
   * 删除结束语题目设置
   */
  delConclusionSubject: (data: any): Promise<any> => {
    return http.post("/activity/question/delConclusionSubject", data);
  },
  /**
   * 更新结束语题目设置
   */
  updateConclusionSubject: (data: any): Promise<any> => {
    return http.post("/activity/question/updateConclusionSubject", data);
  },
  /**
   * pc-白名单设置
   */
  getWhiteSetting: (data: any): Promise<any> => {
    return http.post("/activity/question/white/getSetting", data);
  },
  /**
   * pc-白名单list
   */
  getWhiteList: (data: any): Promise<any> => {
    return http.post("/activity/question/white/getWhiteList", data);
  },
  /**
   * pc-白名单list （分页）
   */
  getWhitePage: (data: any): Promise<any> => {
    return http.post("/activity/question/white/getWhitePage", data);
  },
  /**
   * pc-批量添加白名单
   */
  batchAddWhite: (data: any): Promise<any> => {
    return http.post("/activity/question/white/batchAddWhite", data);
  },
  /**
   * pc-批量删除白名单
   */
  batchDelWhite: (data: any): Promise<any> => {
    return http.post("/activity/question/white/batchDelWhite", data);
  },
  /**
   * pc-更新白名单设置
   */
  updateWhiteSetting: (data: any): Promise<any> => {
    return http.post("/activity/question/white/updateWhiteSetting", data);
  },
  /**
   * 使用用户录入次数
   */
  upDateEntry: (data: any): Promise<any> => {
    return http.post("/activity/user/upDateEntry", data);
  },
  /**
   * 用户录入记录
   */
  getEntryList: (data: any): Promise<any> => {
    return http.post("/activity/user/getEntryList", data);
  },
  /**
   *  余额购买广告额度
   */
  getAdvertPay: (data: any): Promise<any> => {
    return http.post("/active/pay/getAdvertPay", data);
  },
  /**
   *  用户当天的创建问卷数量
   */
  getQuestionCount: (data: any): Promise<any> => {
    return http.post("/activity/user/getQuestionCount", data);
  },
  /**
   *  用户当天的创建问卷题目数
   */
  getSubjectCount: (data: any): Promise<any> => {
    return http.post("/activity/user/getSubjectCount", data);
  },
  /**
   *  一页一题 题型类型设置list
   */
  getSubjectTypeSettingList: (data: any): Promise<any> => {
    return http.post(
      "/activity/question/subjectType/getSubjectTypeSettingList",
      data
    );
  },
  /**
   *  添加题型类型设置
   */
  addSubjectTypeSetting: (data: any): Promise<any> => {
    return http.post(
      "/activity/question/subjectType/addSubjectTypeSetting",
      data
    );
  },
  /**
   *  删除题型类型设置
   */
  delSubjectTypeSetting: (data: any): Promise<any> => {
    return http.post(
      "/activity/question/subjectType/delSubjectTypeSetting",
      data
    );
  },
  /**
   *  更新题型类型设置
   */
  updateSubjectTypeSetting: (data: any): Promise<any> => {
    return http.post(
      "/activity/question/subjectType/updateSubjectTypeSetting",
      data
    );
  },
  /**
   *  批量修改题目必填
   */
  batchUpdateSubjectRequired: (data: any): Promise<any> => {
    return http.post("/activity/question/T2/batchUpdateSubjectRequired", data);
  },
  /**
   *  单个详情下载PDF
   */
  getDownloadPdf: (data: any): Promise<any> => {
    return http.post("/question/statement/T2/getDownloadPdf", data);
  },
  /**
   *  下载问卷详情PDF集合
   */
  getDownloadPdfZip: (data: any): Promise<any> => {
    return http.post("/question/statement/T2/getDownloadPdfZip", data);
  },
  /**
   *  下载问卷题目标题名称
   */
  getPdfName: (data: any): Promise<any> => {
    return http.post("/question/statement/T2/getPdfName", data);
  },
  /**
   *  下载list
   */
  getDownloadList: (data: any): Promise<any> => {
    return http.post("/activity/question/download/getDownloadList", data);
  },
  /**
   *  删除下载记录
   */
  delDownload: (data: any): Promise<any> => {
    return http.post("/activity/question/download/delDownload", data);
  },
  /**
   *  上传word分类报表
   */
  downloadWorldFile: (data: any): Promise<any> => {
    return http.post("/activity/question/download/downloadWorldFile", data);
  },
  /**
   *  分数详情
   */
  getScoreDetail: (data: any): Promise<any> => {
    return http.post("/question/score/statement/getScoreDetail", data);
  },
  /**
   *  分数等级设置list
   */
  getScoreGradeList: (data: any): Promise<any> => {
    return http.post("/question/score/statement/getScoreGradeList", data);
  },
  /**
   *  添加分数等级设置
   */
  addScoreGrade: (data: any): Promise<any> => {
    return http.post("/question/score/statement/addScoreGrade", data);
  },
  /**
   *  删除分数等级设置
   */
  delScoreGrade: (data: any): Promise<any> => {
    return http.post("/question/score/statement/delScoreGrade", data);
  },
  /**
   *  更新分数等级设置
   */
  upDateScoreGrade: (data: any): Promise<any> => {
    return http.post("/question/score/statement/upDateScoreGrade", data);
  },
  /**
   *  分数区间图表
   */
  getScoreChart: (data: any): Promise<any> => {
    return http.post("/question/score/statement/getScoreChart", data);
  },
  /**
   *  分数等级区间图表
   */
  getGradeChart: (data: any): Promise<any> => {
    return http.post("/question/score/statement/getGradeChart", data);
  },
  /**
   *  题目正确率
   */
  getSubjectAccuracy: (data: any): Promise<any> => {
    return http.post("/question/score/statement/getSubjectAccuracy", data);
  },
  /**
   *  问卷报表--交易详情
   */
  getTradeDetail: (data: any): Promise<any> => {
    return http.post("/question/trade/statement/getTradeDetail", data);
  },
  /**
   *  问卷报表--考前订单信息
   */
  getTradeExam: (data: any): Promise<any> => {
    return http.post("/question/trade/statement/getTradeExam", data);
  },
  /**
   *  问卷知情同意书
   */
  getWxQuestionAuthList: (data: any): Promise<any> => {
    return http.post("/activity/question/T2/getWxQuestionAuthList", data);
  },
  /**
   *  新建or更新知情同意书
   */
  saveOrUpdateAuth: (data: any): Promise<any> => {
    return http.post("/activity/question/T2/saveOrUpdateAuth", data);
  },
  /**
   *  删除知情同意书
   */
  delAuth: (data: any): Promise<any> => {
    return http.post("/activity/question/T2/delAuth", data);
  },
  /**
   *  pc-个人题库类型分页
   */
  getStockTypePage: (data: any): Promise<any> => {
    return http.post("/activity/question/bank/getStockTypePage", data);
  },
  /**
   *  pc-个人题库类型list
   */
  getStockTypeList: (data: any): Promise<any> => {
    return http.post("/activity/question/bank/getStockTypeList", data);
  },
  /**
   *  pc-新增个人库存分类
   */
  addStockType: (data: any): Promise<any> => {
    return http.post("/activity/question/bank/addStockType", data);
  },
  /**
   *  pc-修改个人题库类型名称
   */
  updateStockTypeName: (data: any): Promise<any> => {
    return http.post("/activity/question/bank/updateStockTypeName", data);
  },
  /**
   *  pc-删除个人题库类型
   */
  delStockType: (data: any): Promise<any> => {
    return http.post("/activity/question/bank/delStockType", data);
  },
  /**
   *  pc-个人题库题型list
   */
  getStockList: (data: any): Promise<any> => {
    return http.post("/activity/question/bank/getStockList", data);
  },
  /**
   *  pc-添加个人题库类型题目
   */
  addStock: (data: any): Promise<any> => {
    return http.post("/activity/question/bank/addStock", data);
  },
  /**
   *  pc-删除个人题库类型题目
   */
  delStock: (data: any): Promise<any> => {
    return http.post("/activity/question/bank/delStock", data);
  },
  /**
   *  pc-批量删除个人题库类型题目
   */
  batchDelStock: (data: any): Promise<any> => {
    return http.post("/activity/question/bank/batchDelStock", data);
  },
  /**
   *  随机题目打乱
   */
  getSubjectDisruptList: (data: any): Promise<any> => {
    return http.post("/activity/question/random/getSubjectDisruptList", data);
  },
  /**
   *  设置题目打乱
   */
  getSubjectDisruptSetting: (data: any): Promise<any> => {
    return http.post(
      "/activity/question/random/getSubjectDisruptSetting",
      data
    );
  },
  /**
   *  随机题目题型
   */
  randomGetRandomSubjectList: (data: any): Promise<any> => {
    return http.post("/activity/question/random/getRandomSubjectList", data);
  },
  /**
   *  随机题目题型
   */
  addRandomSubject: (data: any): Promise<any> => {
    return http.post("/activity/question/random/addRandomSubject", data);
  },
  /**
   *  更新随机题目数量
   */
  upDateRandomSubject: (data: any): Promise<any> => {
    return http.post("/activity/question/random/upDateRandomSubject", data);
  },
  /**
   *  报表--评价标签
   */
  getAnswerDetailByEvaluateList: (data: any): Promise<any> => {
    return http.post("/question/statement/getAnswerDetailByEvaluateList", data);
  },
  /**
   *  我填写的数据list
   */
  getWriteList: (data: any): Promise<any> => {
    return http.post("/active/write/getWriteList", data);
  },
  /**
   *  填写问卷详情list
   */
  getWriteDetailList: (data: any): Promise<any> => {
    return http.post("/active/write/getWriteDetailList", data);
  },
  /**
   *  彻底删除问卷list
   */
  getThoroughDelQuestionList: (data: any): Promise<any> => {
    return http.post("/activity/question/T2/getThoroughDelQuestionList", data);
  },
  /**
   *  彻底删除数据找回
   */
  findCompletelyDel: (data: any): Promise<any> => {
    return http.post("/activity/question/T2/findCompletelyDel", data);
  },
  /**
   *  预约时间数组
   */
  getAppointmentList: (data: any): Promise<any> => {
    return http.post("/activity/question/appoint/getAppointmentList", data);
  },
  /**
   *  报表--预约问卷数据
   */
  getQuestionAnswerStatement: (data: any): Promise<any> => {
    return http.post(
      "/activity/question/appoint/getQuestionAnswerStatement",
      data
    );
  },
  /**
   *  报表--预约问卷题目
   */
  getSubjectStatement: (data: any): Promise<any> => {
    return http.post("/activity/question/appoint/getSubjectStatement", data);
  },
  /**
   *  报表--取消预约状态
   */
  cancelAppointStatus: (data: any): Promise<any> => {
    return http.post("/activity/question/appoint/cancelAppointStatus", data);
  },
  /**
   *  报表--预约详情下载
   */
  getAppointDownload: (data: any): Promise<any> => {
    return http.post("/activity/question/appoint/getAppointDownload", data);
  },
  /**
   *  报表--接龙问卷题目
   */
  getSolitaireSubject: (data: any): Promise<any> => {
    return http.post("/activity/question/solitaire/getSolitaireSubject", data);
  },
  /**
   *  报表--接龙问卷数据
   */
  getSolitaireAnswerStatement: (data: any): Promise<any> => {
    return http.post(
      "/activity/question/solitaire/getSolitaireAnswerStatement",
      data
    );
  },
  /**
   *  报表--接龙详情下载
   */
  getSolitaireDownload: (data: any): Promise<any> => {
    return http.post("/activity/question/solitaire/getSolitaireDownload", data);
  },
  /**
   *  商品接龙发货
   */
  getSendGood: (data: any): Promise<any> => {
    return http.post("/activity/question/solitaire/getSendGood", data);
  },
  /**
   *  接龙订单详情
   */
  getSolitaireOrderDetail: (data: any): Promise<any> => {
    return http.post(
      "/activity/question/solitaire/getSolitaireOrderDetail",
      data
    );
  },
  /**
   *  更新问卷答案
   */
  updateQuestionAnswer: (data: any): Promise<any> => {
    return http.post("/activity/question/answer/updateQuestionAnswer", data);
  },
  /**
   *  保存搜索来源
   */
  saveSearch: (data: any): Promise<any> => {
    return http.post("/wxApplet/search/saveSearch", data);
  },
  /**
   *  批量删除中奖信息
   */
  batchDelWinDrawPrize: (data: any): Promise<any> => {
    return http.post("/activity/question/draw/batchDelWinDrawPrize", data);
  },
  /**
   *  保存问卷复制or查询字段
   */
  saveQuestionCopyOrSearch: (data: any): Promise<any> => {
    return http.post("/activity/question/T2/saveQuestionCopyOrSearch", data);
  },
  /**
   *  批量修改问卷分值
   */
  batchModifyScore: (data: any): Promise<any> => {
    return http.post("/activity/question/T2/batchModifyScore", data);
  },

  /**
   *  获取问卷题目list
   */
  getScantronSubjectList(data: any): Promise<any> {
    return http.post("/activity/question/T2/getScantronSubjectList", data);
  },

  /**
   * 问卷配额设置列表
   */
  getQuotaSettingList(data: any): Promise<any> {
    return http.post("/activity/question/quota/getQuotaSettingList", data);
  },

  /**
   * 新增普通配额设置
   */
  saveQuotaSetting(data: any): Promise<any> {
    return http.post("/activity/question/quota/saveQuotaSetting", data);
  },

  /**
   * 更新配额名称
   */
  updateQuotaName(data: any): Promise<any> {
    return http.post("/activity/question/quota/updateQuotaName", data);
  },

  /**
   * 删除配额设置
   */
  delQuotaSetting(data: any): Promise<any> {
    return http.post("/activity/question/quota/delQuotaSetting", data);
  },

  /**
   * 问卷配额选项列表
   */
  getQuotaOptionList(data: any): Promise<any> {
    return http.post("/activity/question/quota/getQuotaOptionList", data);
  },

  /**
   * 配额题目选项
   */
  getQuotaSubjectList(data: any): Promise<any> {
    return http.post("/activity/question/quota/getQuotaSubjectList", data);
  },

  /**
   * 保存or修改配额选项
   */
  saveOrUpdateQuotaOption(data: any): Promise<any> {
    return http.post("/activity/question/quota/saveOrUpdateQuotaOption", data);
  },

  /**
   * 更新配额数量
   */
  updateQuotaQuantity(data: any): Promise<any> {
    return http.post("/activity/question/quota/updateQuotaQuantity", data);
  },

  /**
   * 删除配额选项
   */
  delQuotaOption(data: any): Promise<any> {
    return http.post("/activity/question/quota/delQuotaOption", data);
  },

  /**
   * 配额报表
   */
  getQuotaStatement(data: any): Promise<any> {
    return http.post("/question/quota/statement/getQuotaStatement", data);
  },

  /**
   * 定制172760 ：今日排行榜
   */
  getQuestionScoreRankByToday: (data: any): Promise<any> => {
    return http.post(
      "/v2/question/statement/getQuestionScoreRankByToday",
      data
    );
  },
  /**
   * 定制172760 238558 ：获取累计每日最高分
   */
  getHighestScoreRank: (data: any): Promise<any> => {
    return http.post("/v2/question/statement/getHighestScoreRank", data);
  },
  /**
   * 定制172760 238558 ：导出累计每日最高分
   */
  getHighestScoreDownload: (data: any): Promise<any> => {
    return http.post("/v2/question/statement/getHighestScoreDownload", data);
  },
  /**
   *  余额购买风控额度
   */
  getRiskControlPay: (data: any): Promise<any> => {
    return http.post("/active/pay/getRiskControlPay", data);
  },
  /**
   *  问卷ID： 56665  定制下载按钮
   */
  getDownloadRedParkByWinDraw: (data: any): Promise<any> => {
    return http.post(
      "/activity/question/redPack/getDownloadRedParkByWinDraw",
      data
    );
  },
  /**
   *  短信回执page
   */
  getMessageReceiptPage: (data: any): Promise<any> => {
    return http.post("/activity/message/receipt/getMessageReceiptPage", data);
  },
  /**
   *  保存or更新短信回执-- 修改内容会再次审核
   */
  saveOrUpdateMessageReceipt: (data: any): Promise<any> => {
    return http.post(
      "/activity/message/receipt/saveOrUpdateMessageReceipt",
      data
    );
  },
  /**
   *  短信回执详情
   */
  getMessageReceiptDetail: (data: any): Promise<any> => {
    return http.post("/activity/message/receipt/getMessageReceiptDetail", data);
  },
  /**
   *  修改发送状态
   */
  updateSendStatus: (data: any): Promise<any> => {
    return http.post("/activity/message/receipt/updateSendStatus", data);
  },
  /**
   *  删除短信回执
   */
  delMessageReceipt: (data: any): Promise<any> => {
    return http.post("/activity/message/receipt/delMessageReceipt", data);
  },
  /**
   *  短信发送记录page
   */
  getMessageSendRecordPage: (data: any): Promise<any> => {
    return http.post(
      "/activity/message/receipt/getMessageSendRecordPage",
      data
    );
  },
  /**
   *  短信发送记录详情
   */
  getMessageSendRecordDetail: (data: any): Promise<any> => {
    return http.post(
      "/activity/message/receipt/getMessageSendRecordDetail",
      data
    );
  },
  /**
   *  重新发送短信
   */
  getAgainSendMessage: (data: any): Promise<any> => {
    return http.post("/activity/message/receipt/getAgainSendMessage", data);
  },
  // 数据详情的题目
  getDataSubjectList: (data: any): Promise<any> => {
    return http.post("/v2/question/statement/getDataSubjectList", data);
  },
  // 报表数据详情加题目答案
  getDataDetail: (data: any): Promise<any> => {
    return http.post("/v2/question/statement/getDataDetail", data);
  },
  // 批量下载题目附件
  getAllZipFile: (data: any): Promise<any> => {
    return http.post("/question/statement/getAllZipFile", data);
  },
  // 批量下载题目附件 关联题目
  getAllZipFileBySubjectName: (data: any): Promise<any> => {
    return http.post("/question/statement/getAllZipFileBySubjectName", data);
  },
  // 当月订单量
  getOrderMonthAmount: (data: any): Promise<any> => {
    return http.post("/active/commodity/order/getOrderMonthAmount", data);
  },
  // 置顶
  updateQuestionTop: (data: any): Promise<any> => {
    return http.post("/activity/question/updateQuestionTop", data);
  },
};
